import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M3 3.25C2.58579 3.25 2.25 3.58579 2.25 4C2.25 4.41421 2.58579 4.75 3 4.75H4.70455V14.7928C3.29653 15.1305 2.25 16.3976 2.25 17.9091C2.25 19.679 3.68472 21.1137 5.45455 21.1137C6.96611 21.1137 8.23323 20.0671 8.57086 18.6591H21C21.4142 18.6591 21.75 18.3233 21.75 17.9091C21.75 17.4949 21.4142 17.1591 21 17.1591H8.57083C8.29088 15.9917 7.37196 15.0728 6.20455 14.7928V4C6.20455 3.58579 5.86876 3.25 5.45455 3.25H3ZM5.45455 16.2046C4.51315 16.2046 3.75 16.9677 3.75 17.9091C3.75 18.8505 4.51315 19.6137 5.45455 19.6137C6.39594 19.6137 7.15909 18.8505 7.15909 17.9091C7.15909 16.9677 6.39594 16.2046 5.45455 16.2046ZM11.5455 4.88623C10.0267 4.88623 8.79547 6.11745 8.79547 7.63623V11.818C8.79547 13.3368 10.0267 14.568 11.5455 14.568H17.3637C18.8824 14.568 20.1137 13.3368 20.1137 11.818V7.63623C20.1137 6.11745 18.8824 4.88623 17.3637 4.88623H11.5455ZM10.2955 7.63623C10.2955 6.94587 10.8551 6.38623 11.5455 6.38623H17.3637C18.054 6.38623 18.6137 6.94588 18.6137 7.63623V11.818C18.6137 12.5084 18.054 13.068 17.3637 13.068H11.5455C10.8551 13.068 10.2955 12.5084 10.2955 11.818V7.63623Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const WarehouseOutlined = React.forwardRef(IconComponent);
WarehouseOutlined.displayName = 'WarehouseOutlined';

export { WarehouseOutlined };
